import { Fetcher } from "openapi-typescript-fetch";
import type { z } from "zod";
import { schemas } from "./decoder";
import type { paths } from "./types";

export const api = Fetcher.for<paths>();

export { schemas as apiDecoder };

export type ImageGeneratorName = z.infer<
	(typeof schemas)["ImageGeneratorName"]
>;
